import React from 'react';
import ChoiceButton from './ChoiceButton';

const sleepColorScheme = {
  bgColor: '#F5F3FF',
  labelShadowColor: 'rgba(139, 92, 246, 0.40)',
  labelDropShadowColor: 'rgba(139, 92, 246, 0.40)',
  textColor: '#8B5CF6',
  activeGradientStart: '#5B21B6',
  activeGradientEnd: '#8B5CF6',
  activeBorderGradientStart: '#DDD6FE',
  activeBorderGradientEnd: '#6D28D9',
  activeBoxShadowColor: '#C4B5FD',
  activeLabelInnerBg: '#8B5CF6',
};

const SleepChoiceButton = (props) => {
  return <ChoiceButton {...props} colorScheme={sleepColorScheme} />;
};

export default SleepChoiceButton;
